import { createIcon } from "@chakra-ui/icons";

// Created from send-icon.svg

export const SendIcon = createIcon({
  displayName: "SendIcon",
  viewBox: "0 0 17 17",
  path: (
    <path
      d="M1.29677 1.38742L15.5145 8.83008L1.00739 15.6916L4.57128 8.60869L1.29677 1.38742Z"
      stroke="currentColor"
      fill="transparent"
      strokeLinejoin="round"
    />
  ),
});
